import { SourcePlatform } from '../types';

export const getPlatformHeader = (sourcePlatform: SourcePlatform): Record<string, string> => {
  return {
    'X-Smg-Platform': sourcePlatform,
  };
};
